"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Data = void 0;
var stack_1 = require("@devexpress/utils/lib/class/stack");
var list_1 = require("@devexpress/utils/lib/utils/list");
var constants_1 = require("../utils/constants");
var zip_builder_1 = require("../zip/zip-builder");
var character_properties_1 = require("./exporters/base/character-properties");
var color_1 = require("./exporters/base/color");
var paragraph_properties_1 = require("./exporters/base/paragraph-properties");
var character_style_1 = require("./exporters/base/styles/character-style");
var numbering_style_1 = require("./exporters/base/styles/numbering-style");
var paragraph_style_1 = require("./exporters/base/styles/paragraph-style");
var table_style_1 = require("./exporters/base/styles/table-style");
var table_properties_1 = require("./exporters/base/table/table-properties");
var width_exporter_1 = require("./exporters/base/table/width-exporter");
var text_1 = require("./exporters/base/text");
var content_types_1 = require("./exporters/content-types");
var styles_1 = require("./exporters/styles");
var text_box_content_exporter_1 = require("./exporters/sub-document/text-box-content-exporter");
var id_generator_1 = require("./utils/id-generator");
var writer_helper_1 = require("./utils/writer-helper");
var Data = (function () {
    function Data(model, options) {
        this.drawingElementId = 1;
        this.exportSubDocumentsList = [];
        this.relationExporters = [];
        this.model = model;
        this.options = options;
        this.constants = new constants_1.DocxConstants();
        this.writerStack = new stack_1.Stack();
        this.zipBuilder = new zip_builder_1.ZipBuilder();
        this.writerHelper = new writer_helper_1.WriterHelper();
        this.idGenerator = new id_generator_1.IdGenerator();
        this.subDocumentExporterStack = new stack_1.Stack();
        this.relationExporters = [];
        this.tableWidthExporter = new width_exporter_1.TableWidthExporter(this);
        this.charPropsExporter = new character_properties_1.CharacterPropertiesExporter(this);
        this.parPropsExporter = new paragraph_properties_1.ParagraphPropertiesExporter(this);
        this.tablePropsExporter = new table_properties_1.TablePropertiesExporter(this);
        this.colorExporter = new color_1.ColorExporter(this);
        this.parStyleExporter = new paragraph_style_1.ParagraphStyleExporter(this);
        this.charStyleExporter = new character_style_1.CharacterStyleExporter(this);
        this.tblStyleExporter = new table_style_1.TableStyleExporter(this);
        this.numberingStyleExporter = new numbering_style_1.NumberingStyleExporter(this);
        this.textExporter = new text_1.TextExporter(this);
        this.styleExporter = new styles_1.StylesExporter(this);
        this.contentTypesExporter = new content_types_1.ContentTypesExporter(this);
        this.exportedImageTable = {};
    }
    Object.defineProperty(Data.prototype, "writer", {
        get: function () { return this.writerStack.last; },
        set: function (val) { this.writerStack.push(val); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Data.prototype, "subDocumentExporter", {
        get: function () { return this.subDocumentExporterStack.last; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Data.prototype, "relationExporter", {
        get: function () { return list_1.ListUtils.last(this.relationExporters); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Data.prototype, "mainSubDocumentRelations", {
        get: function () { return this.relationExporters[0]; },
        enumerable: false,
        configurable: true
    });
    Data.prototype.popWriter = function () { this.writerStack.pop(); };
    Data.prototype.pushRelationExporter = function (exporter) { this.relationExporters.push(exporter); };
    Data.prototype.popRelationExporter = function () { this.relationExporters.pop().export(); };
    Data.prototype.createTextBoxExporter = function (subDoc) {
        return new text_box_content_exporter_1.TextBoxSubDocumentExporter(this, subDoc);
    };
    Data.prototype.init = function () {
        this.headerCounter = 0;
        this.footerCounter = 0;
    };
    return Data;
}());
exports.Data = Data;
